import http from 'utils/http';

export const fetchUserCards = ({ userId, paymentMethod }) => http
  .get(`v1/user/call-in-orders/card/?unique=1&user_id=${userId}`, paymentMethod && { headers: { payment_method: paymentMethod } })
  .then((res) => res.data);

export const createStripeIntent = (userId) => http
  .get(`v1/user/call-in-orders/card/setup-intent/?user_id=${userId}`)
  .then(({ data }) => data);
